import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const dragSlice = createSlice({
  name: 'drag',
  initialState: {
    source: '',
    destination: '',
    eventType: '',
    isTripGenerated : false,
    items:{}
  },
  reducers: {
    drageItemsReducer: (state, action) => {
      state.source = action.payload.source;
      state.destination = action.payload.destination;
      state.eventType = action.payload.eventType;
      state.isTripGenerated = action.payload.isTripGenerated;
      state.items = action.payload.items;
      return state;
    },
    updateSelectedSums: (state, action) => {
      const { selectedVolumeSum, selectedWeightSum,selectedLLSum,selectedMovementsSum } = action.payload;
      return {
        ...state,
        selectedVolumeSum,
        selectedWeightSum,
        selectedLLSum,
        selectedMovementsSum
      };
    },
  }
})
// case under reducers becomes an action 
export const { drageItemsReducer,updateSelectedSums } = dragSlice.actions
export default dragSlice.reducer 
